import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Recycle, Truck, Trash2 } from "lucide-react";
import { IMG } from "../data/content";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const FEATURES = [
  { icon: Recycle, t: "Recurring property cleanup" },
  { icon: Trash2, t: "Debris clearing" },
  { icon: Truck, t: "Responsive roll-off & waste management" },
];

export const Waste = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="waste" ref={ref} data-testid="waste-section" className="relative bg-[#0B0C10] py-6 sm:py-10">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <div className="relative rounded-[6px] overflow-hidden bg-[#121316] border border-white/10 grid lg:grid-cols-2">
          <div className="relative min-h-[280px] lg:min-h-[520px] overflow-hidden order-1 lg:order-2">
            <motion.img style={{ y }} src={IMG.waste} alt="Waste roll-off truck" className="absolute inset-0 -top-[12%] h-[124%] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-[#121316] via-[#121316]/30 to-transparent" />
          </div>
          <div className="relative p-7 sm:p-12 lg:p-16 order-2 lg:order-1">
            <Reveal>
              <p className="eyebrow text-[#FF6B00]">
                <span className="inline-block w-6 h-px bg-current align-middle mr-3" />Sister Division
              </p>
              <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl tracking-[-0.03em] leading-[0.95] text-white">
                Need waste <br />solutions?
              </h2>
              <p className="mt-5 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-lg">
                Partnered with <span className="text-white font-semibold">Cornerstone Waste Solutions Canada Ltd.</span> — dedicated waste services directly integrated into your LHGS account.
              </p>
              <ul className="mt-8 space-y-3">
                {FEATURES.map(({ icon: I, t }) => (
                  <li key={t} className="flex items-center gap-4 border-b border-white/10 pb-3">
                    <I className="h-5 w-5 text-[#FF6B00]" />
                    <span className="text-white font-medium">{t}</span>
                  </li>
                ))}
              </ul>
              <button onClick={() => scrollToId("contact")} data-testid="waste-cta" className="btn-primary btn-lg mt-10">
                Add waste services <ArrowRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
